export const FOCUS_MODE_CENTER = 'center';

export const FOCUS_MODE_LEFT = 'left';

export const FOCUS_MODES = [FOCUS_MODE_CENTER, FOCUS_MODE_LEFT];

export const START_POINT_MODE_CENTER = 'center';

export const START_POINT_MODE_LEFT = 'left';

export const START_POINT_MODES = [START_POINT_MODE_CENTER, START_POINT_MODE_LEFT];
